import AmCharts from "../Pages/Charts/Amchart.js";
import ApexCharts from "../Pages/Charts/ApexCharts";
import BasicTable from "../Pages/Tables/BasicTable.js";
import ChartJs from "../Pages/Charts/ChartjsCharts";
import Dashboard from "../Pages/Dashboard";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";
import FAQs from "../Pages/Utility/FAQs-Page";
import FloatChart from "../Pages/Charts/FloatCharts";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import FormAdvanced from "../Pages/Forms/FormAdvanced";
import FormEditors from "../Pages/Forms/FormEditors";
import FormElements from "../Pages/Forms/FormElements";
import FormMask from "../Pages/Forms/FormMask";
import FormUpload from "../Pages/Forms/FormUpload";
import FormValidations from "../Pages/Forms/FormValidations";
import FormWizard from "../Pages/Forms/FormWizard";
import FormXeditable from "../Pages/Forms/FormXeditable";
import GoogleMap from "../Pages/Maps/GoogleMap";
import IconBoxicons from "../Pages/Icons/IconBoxicons";
import IconDripicons from "../Pages/Icons/IconDrip";
import IconFontawesome from "../Pages/Icons/IconFontAwesome";
import IconMaterialdesign from "../Pages/Icons/IconMaterialdesign";
import IndividaluUnitReport from "../Pages/IndividualUnit/index.js";
import IndividualTeacherReport from "../Pages/IndividualTeacherReport/indivualTeacher";
import JknobCharts from "../Pages/Charts/JqueryKnobCharts";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";
import Login from "../Pages/Authentication/Login";
import Login1 from "../Pages/AuthenticationPages/Login";
import Logout from "../Pages/Authentication/Logout";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import React from "react";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import Settings from "../Pages/Settings/index.js";
import Sparklinechart from "../Pages/Charts/SparklineCharts";
import StudentDetailsPage from "../Pages/IndividualTeacherReport/StudentDetails.js";
import StudentDetailsPageUnit from "../Pages/IndividualUnit/StudentDetails.js";
import StudentVoiceanalytics from "../Pages/IndividualTeacherReport/studentvoiceAnalytics.js";
import StudentVoiceanalyticsVideo from "../Pages/IndividualTeacherReport/studentvoiceAnalyticsvideo.js";
import TeacherDeployed from "../Pages/IndividualUnit/teachersDeployed.js";
import TeacherQc from "../Pages/TeacherQc/index.js";
import Transcription from "../Pages/Transcription/Transcription.js";
import UiAlerts from "../Pages/UiElements/UiAlerts";
import UiBadge from "../Pages/UiElements/UiBadge";
import UiBreadcrumb from "../Pages/UiElements/UiBreadcrumb";
import UiButtons from "../Pages/UiElements/UiButtons";
import UiCards from "../Pages/UiElements/UiCards";
import UiCarousel from "../Pages/UiElements/UiCarousel";
import UiDropdown from "../Pages/UiElements/UiDropdowns";
import UiGrid from "../Pages/UiElements/UiGrid";
import UiImages from "../Pages/UiElements/UiImages";
import UiLightbox from "../Pages/UiElements/UiLightbox";
import UiModals from "../Pages/UiElements/UiModals";
import UiOffcanvas from "../Pages/UiElements/UiOffcanvas";
import UiPagination from "../Pages/UiElements/UiPagination";
import UiPlaceholders from "../Pages/UiElements/UiPlaceholders";
import UiPopovers from "../Pages/UiElements/UiPopovers&Tooltips";
import UiProgressBars from "../Pages/UiElements/UiProgressBars";
import UiRangeSlider from "../Pages/UiElements/UiRangeSlider";
import UiRating from "../Pages/UiElements/UiRating";
import UiSessionTimeout from "../Pages/UiElements/UiSessionTimeout";
import UiTabs from "../Pages/UiElements/UiTabs&Accordions";
import UiTypography from "../Pages/UiElements/UiTypography";
import UnitQc from "../Pages/UnitQc/index.js";
import UnitStudentTech from "../Pages/IndividualUnit/Unitstudtech";
import UserProfile from "../Pages/Authentication/user-profile";
import VectorMaps from "../Pages/Maps/VectorMap";
import WebinarAnalytics from "../Pages/IndividualTeacherReport/webinarAnalytics";
import Resource from "../../src/components/Common/resource.js";

import { Navigate } from "react-router-dom";

//Dashboard

// Import E-mail

// Import Authentication pages

// Import Authentication Inner Pages

// Import Utility Pages

// Import UIElement Pages

// Import Forms

// Import Tables

// Import Transcription

//settings

//dashboard

// Import Charts

// Import Icon Pages

// Import Map Pages

const authProtectedRoutes = [
  // Profile
  { path: '/userprofile', component: <UserProfile /> },

  // E-mail
  { path: '/teacherqc', component: <TeacherQc /> },

  // Utility Pages

  { path: '/pages-faqs', component: <FAQs /> },

  // UiElements Pages
  { path: '/ui-alerts', component: <UiAlerts /> },
  { path: '/ui-badge', component: <UiBadge /> },
  { path: '/ui-breadcrumb', component: <UiBreadcrumb /> },
  { path: '/design-system-buttons', component: <UiButtons /> },
  { path: '/design-system-cards', component: <UiCards /> },
  { path: '/ui-carousel', component: <UiCarousel /> },
  { path: '/ui-dropdowns', component: <UiDropdown /> },
  { path: '/ui-grid', component: <UiGrid /> },
  { path: '/ui-images', component: <UiImages /> },
  { path: '/ui-lightbox', component: <UiLightbox /> },
  { path: '/ui-modals', component: <UiModals /> },
  { path: '/ui-offcanvas', component: <UiOffcanvas /> },
  { path: '/ui-rangeslider', component: <UiRangeSlider /> },
  { path: '/ui-sessiontimeout', component: <UiSessionTimeout /> },
  { path: '/ui-pagination', component: <UiPagination /> },
  { path: '/ui-progressbars', component: <UiProgressBars /> },
  { path: '/ui-placeholders', component: <UiPlaceholders /> },
  { path: '/ui-tabs-accordions', component: <UiTabs /> },
  { path: '/design-system-typography', component: <UiTypography /> },
  { path: '/ui-popovers', component: <UiPopovers /> },
  { path: '/ui-rating', component: <UiRating /> },

  // Forms pages
  { path: '/design-system-form-elements', component: <FormElements /> },
  { path: '/form-validation', component: <FormValidations /> },
  { path: '/form-advanced', component: <FormAdvanced /> },
  { path: '/form-editor', component: <FormEditors /> },
  { path: '/form-uploads', component: <FormUpload /> },
  { path: '/form-editors', component: <FormXeditable /> },
  { path: '/form-wizard', component: <FormWizard /> },
  { path: '/form-mask', component: <FormMask /> },

  // Tables pages
  { path: '/tables-basic', component: <BasicTable /> },

  // Charts Pages
  { path: '/chart-apexcharts', component: <ApexCharts /> },
  { path: '/chart-amcharts', component: <AmCharts /> },
  { path: '/chart-chartjscharts', component: <ChartJs /> },
  { path: '/chart-chartjscharts', component: <ChartJs /> },
  { path: '/chart-floatcharts', component: <FloatChart /> },
  { path: '/chart-jknobcharts', component: <JknobCharts /> },
  { path: '/chart-sparklinecharts', component: <Sparklinechart /> },

  // Icons Pages
  { path: '/icon-boxicon', component: <IconBoxicons /> },
  { path: '/icons-materialdesign', component: <IconMaterialdesign /> },
  { path: '/icons-fontawesome', component: <IconFontawesome /> },
  { path: '/icon-dripicons', component: <IconDripicons /> },

  // Maps Pages
  { path: '/maps-vector', component: <VectorMaps /> },
  { path: '/maps-google', component: <GoogleMap /> },

  {
    path: '/individualteacher/studentDetails',
    component: <StudentDetailsPage />,
  },

  { path: '/transcription', component: <Transcription /> },

  { 
    path: '/individualteacher',
    component: <IndividualTeacherReport /> 
  },

  {
    path: '/individualteacher/studentdeatilsvoiceanalytics',
    component: <StudentVoiceanalytics />,
  },
  {
    path: '/individualteacher/webinarAnalytics',
    component: <WebinarAnalytics />,
  },
   {
    path: '/resources',
    component: <Resource />,
  },

  { path: '/unitqc', component: <UnitQc /> },
  { path: '/individalunitreport', component: <IndividaluUnitReport /> },

  {
    path: 'individalunitreport/studentdeatilsunit',
    component: <StudentDetailsPageUnit />,
  },


  // studentdeatilsvoiceanalytics
  {
    path: 'studentdeatilsvoiceanalyticsvideo',
    component: <StudentVoiceanalyticsVideo />,
  },

  { path: '/settings', component: <Settings /> },

  {
    path: '/individalunitreport/unitstuddetails',
    component: <UnitStudentTech />,
  },

  {
    path: '/individalunitreport/teacherdeployed',
    component: <TeacherDeployed />,
  },

  //dshboard
  { path: '/dashboard', component: <Dashboard /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: '/',
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: '/logout', component: <Logout /> },
  { path: '/login', component: <Login /> },
  { path: '/forgot-password', component: <ForgetPasswordPage /> },

  // Authentication Inner Pages
  { path: '/auth-login', component: <Login1 /> },
  { path: '/auth-recoverpw', component: <RecoverPassword /> },
  { path: '/auth-lock-screen', component: <LockScreen /> },

  // Utility Pages
  { path: '/pages-404', component: <Error404 /> },
  { path: '/pages-500', component: <Error500 /> },
  { path: '/pages-maintenance', component: <Maintenance /> },
];

export { authProtectedRoutes, publicRoutes };
